/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "767b81fd35cb90f9a3ba6ddc6a73382973978d86";
